// Shared contract between the three writers of the theme's CSS custom
// properties: CampaignThemeProvider (runtime, source of truth), the inline
// bootstrap in public/index.html (localStorage replay, pre-paint), and
// scripts/inline-theme.js (build-time bake). All three write inline styles on
// documentElement so none can lose to a stylesheet — or to each other by
// specificity, only by order.
//
// Changing the key or the envelope shape means older cached snapshots must be
// rejected, not misread: bump THEME_BOOTSTRAP_VERSION and the key suffix
// together, and update the literals hard-coded in public/index.html.

export const THEME_BOOTSTRAP_KEY = 'p4a-theme-bootstrap-v1';
export const THEME_BOOTSTRAP_TTL_MS = 1000 * 60 * 60 * 24 * 30; // 30 days
export const THEME_BOOTSTRAP_VERSION = 1;

export type ThemeDeclarations = {
  /** Fully-qualified custom property names, e.g. '--bs-primary', '--font-body'. */
  vars: Record<string, string>;
  /** Names to clear from the live DOM. Never persisted — a snapshot only
   *  carries what should be set, so a replay can never resurrect a removal. */
  removals: string[];
};

export type ThemeSnapshot = {
  v: number;
  vars: Record<string, string>;
  isDark: boolean;
};
